var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, computed, action } from 'mobx';
import { lengths, randomString, round } from 'helpers/Utils';
export class TempSaleExtraLine {
    // constructor
    constructor(saleExtra, value) {
        // setters
        this.setQuantity = (quantity) => {
            this.quantity = quantity;
        };
        this.setExtraPrice = (priceExtra) => {
            this.priceExtra = priceExtra;
        };
        this.setTax = (tax) => {
            this.tax = tax;
        };
        // toJSON
        this.toJSON = () => {
            return {
                price: round(this.priceExtra.price, 2),
                extra_id: this.priceExtra.id,
                extraName: this.priceExtra.name,
                description: this.priceExtra.description,
                quantity: this.quantity,
                taxBase: this.base,
                taxAmount: this.taxAmount,
                tax_id: this.tax.id,
                taxName: this.tax.name,
                taxValue: this.tax.value,
                total: this.total,
                printDescription: true,
                isIncluded: this.saleExtra.isIncluded,
                qrCode: randomString(lengths.extra)
            };
        };
        // console.log('TempSaleExtraLine - saleExtra: ', saleExtra)
        this.saleExtra = saleExtra;
        this.quantity = value ? value : 1;
        this.priceExtra = saleExtra.price;
        this.tax = saleExtra.price.tax;
    }
    // getters
    get base() {
        return round(this.priceExtra.price * this.quantity);
    }
    get taxes() {
        return this.tax.value;
    }
    get taxAmount() {
        return round(this.tax.value * this.priceExtra.price * this.quantity);
    }
    get total() {
        console.log('total: ', this.base + this.taxAmount);
        return round(this.base + this.taxAmount, 2);
    }
}
__decorate([
    observable
], TempSaleExtraLine.prototype, "quantity", void 0);
__decorate([
    observable
], TempSaleExtraLine.prototype, "priceExtra", void 0);
__decorate([
    observable
], TempSaleExtraLine.prototype, "tax", void 0);
__decorate([
    computed
], TempSaleExtraLine.prototype, "base", null);
__decorate([
    computed
], TempSaleExtraLine.prototype, "taxes", null);
__decorate([
    computed
], TempSaleExtraLine.prototype, "taxAmount", null);
__decorate([
    computed
], TempSaleExtraLine.prototype, "total", null);
__decorate([
    action
], TempSaleExtraLine.prototype, "setQuantity", void 0);
__decorate([
    action
], TempSaleExtraLine.prototype, "setExtraPrice", void 0);
__decorate([
    action
], TempSaleExtraLine.prototype, "setTax", void 0);



//////////////////
// WEBPACK FOOTER
// ./src/modules/TempSale/TempSaleExtraLine.ts
// module id = 363
// module chunks = 0